import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { getGroups } from '../../services/groupService';
import {
  editingGroupState,
  groupsPageState,
  groupsState,
  loadingGroupsState,
  searchGroupState,
  selectedGroupIdState,
  updateGroupsState,
} from '../../storage/groups';
import { Group } from '../../types/group';
import { PaginatedProvider } from './PaginatedProvider';

function GroupsProvider() {
  const updateGroups = useRecoilValue(updateGroupsState);
  const setLoadingGroups = useSetRecoilState(loadingGroupsState);
  const setPaginatedGroups = useSetRecoilState(groupsState);
  const resetEditingGroup = useResetRecoilState(editingGroupState);
  const resetSelectedGroupId = useResetRecoilState(selectedGroupIdState);
  const resetUpdateGroups = useResetRecoilState(updateGroupsState);

  return (
    <PaginatedProvider<Group>
      searchState={searchGroupState}
      pageState={groupsPageState}
      getPaginated={getGroups}
      setPaginated={setPaginatedGroups}
      onSearchChange={resetSelectedGroupId}
      onUpdateFinish={() => {
        resetUpdateGroups();
        resetEditingGroup();
      }}
      setLoading={setLoadingGroups}
      update={updateGroups}
    />
  );
}

export default GroupsProvider;
